import { AppointmentView, CurrentAppointmentViewQuery } from '@dreryk/egabinet-dashboard-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../../translations';

type RegisteredAppointmentsRenderProps = {
   appointmentsView: AppointmentView[];
};

type RegisteredAppointmentsLoaderProps = {
   readonly children: (renderProps: RegisteredAppointmentsRenderProps) => JSX.Element;
};

export const RegisteredAppointmentsLoader = (props: RegisteredAppointmentsLoaderProps): JSX.Element => {
   const {
      data: appointmentsView,
      loading: appointmentsViewLoading,
      error: appointmentsViewError,
   } = useCqrsSearch<AppointmentView>(() => new CurrentAppointmentViewQuery());

   if (appointmentsViewLoading) {
      return <LoaderSpinner />;
   }

   if (appointmentsViewError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={dashboardTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      appointmentsView: appointmentsView,
   });
};
